import { Tag } from '@cbhq/cds-web/tag/Tag';
import { cx, css } from '@emotion/css';
import { forwardRef, memo } from 'react';

const TagLabelCss = css`
  > span {
    font-weight: 400;
  }
`;

export const TagLabel: typeof Tag = memo(
  forwardRef(function TagLabel({ children, className, ...props }, ref) {
    return (
      <Tag paddingX={1} height={22} {...props} ref={ref} className={cx(className, TagLabelCss)}>
        {children}
      </Tag>
    );
  }),
);
